import React from 'react';
import { LayoutGrid, LayoutList } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface ViewToggleProps {
  view: 'list' | 'grid';
  onViewChange: (view: 'list' | 'grid') => void;
}

export const ViewToggle: React.FC<ViewToggleProps> = ({ view, onViewChange }) => {
  const { t } = useTranslation('common');

  return (
    <div className="flex items-center bg-neutral-200/50 dark:bg-neutral-800/50 rounded-lg p-0.5 border border-neutral-200 dark:border-neutral-800">
      <button
        onClick={() => onViewChange('list')}
        className={`flex items-center gap-1.5 px-3 py-1 rounded-md transition-all duration-200 ${
          view === 'list'
            ? 'bg-white dark:bg-neutral-700 shadow-sm text-accent-primary'
            : 'text-neutral-500 hover:text-neutral-700 dark:hover:text-neutral-300 hover:bg-neutral-200/50 dark:hover:bg-neutral-700/30'
        }`}
      >
        <LayoutList className="w-3.5 h-3.5" />
        <span className="text-[10px] font-semibold uppercase tracking-wider">{t('boards.list')}</span>
      </button>
      <button
        onClick={() => onViewChange('grid')}
        className={`flex items-center gap-1.5 px-3 py-1 rounded-md transition-all duration-200 ${
          view === 'grid'
            ? 'bg-white dark:bg-neutral-700 shadow-sm text-accent-primary'
            : 'text-neutral-500 hover:text-neutral-700 dark:hover:text-neutral-300 hover:bg-neutral-200/50 dark:hover:bg-neutral-700/30'
        }`}
      >
        <LayoutGrid className="w-3.5 h-3.5" />
        <span className="text-[10px] font-semibold uppercase tracking-wider">{t('boards.grid')}</span>
      </button>
    </div>
  );
};
